import { LeaderboardType, LeaderboardDuration } from 'jigsaw';
import { Tabs, TabsList, TabsTrigger, Text } from 'ui_2';
import parc_logo from '@assets/parc.png';
import part_logo from '@assets/part.png';

type LeaderboardTypeTabsProps = {
  value: LeaderboardType;
  onChange: (v: LeaderboardType) => void;
};

const TABS = [
  {
    type: LeaderboardType.PARC,
    label: 'PARC',
    img: parc_logo,
  },
  {
    type: LeaderboardType.PART,
    label: 'PART',
    img: part_logo,
  },
];

export const LeaderboardTypeTabs = ({
  value,
  onChange,
}: LeaderboardTypeTabsProps) => {
  return (
    <div className='flex w-full justify-center gap-8 border-b border-b-gray-100 bg-white'>
      {TABS.map((tab) => {
        const isActive = value === tab.type;
        return (
          <button
            key={tab.type}
            onClick={() => onChange(tab.type)}
            className={`flex w-[60px] flex-col items-center border-b-[5px] pb-1 transition-all duration-200 focus:outline-none ${
              isActive ? 'border-b-black' : 'border-transparent'
            }`}
            type='button'
          >
            <img
              src={tab.img}
              alt={tab.label}
              className={`mb-2 h-6 ${isActive ? '' : 'opacity-50 grayscale'}`}
            />
            <Text font='medium-xs' color={isActive ? 'black' : 'gray-500'}>
              {tab.label}
            </Text>
          </button>
        );
      })}
    </div>
  );
};

const DURATION_LABELS = {
  [LeaderboardDuration.Day]: 'Today',
  [LeaderboardDuration.Week]: 'Week',
  [LeaderboardDuration.Month]: 'Month',
};

type LeaderboardDurationTabsProps = {
  value: LeaderboardDuration;
  onChange: (v: LeaderboardDuration) => void;
};

export const LeaderboardDurationTabs = ({
  value,
  onChange,
}: LeaderboardDurationTabsProps) => {
  return (
    <div className='flex w-full justify-center gap-8 border-b border-b-gray-100 bg-white'>
      {Object.entries(DURATION_LABELS).map(([d, label]) => {
        const isActive = value === d;
        return (
          <button
            key={d}
            onClick={() => onChange(d as LeaderboardDuration)}
            className={`flex w-[80px] flex-col items-center border-b-[2px] pb-1 transition-all duration-200 focus:outline-none ${
              isActive ? 'border-b-black' : 'border-transparent'
            }`}
            type='button'
          >
            <Text font='medium-xs' color={isActive ? 'black' : 'gray-500'}>
              {label}
            </Text>
          </button>
        );
      })}
    </div>
  );
};
